<template>
    <div class="header">
        <div class="h_left clearfix">
            <a href="http://www.chineseplus.net/">
                <img src="../img/chineselogo.png" class="chineselogo">
            </a>
            <span class="title">{{ $t('message.live') }}</span>
        </div>
        <div class="h_right">
            <div class="languageCon">
                <img src="../img/language.png" class="languageIcon">
                <span v-on:click="changeLanguage" class="iconWrapper languageWrapper" ><span class="languageIcon"></span>{{language}}</span>
            </div>
            <slot name="logincon"></slot>
        </div>
    </div>
</template>

<script>
import { setup } from "../../locales"
export default {
    name: 'ztHeader',
    computed: {
        language: {
            get() {
                return this.languageList[this.languageIndex].val;
            },
            set() {
                return this.languageList[this.languageIndex].val;
            }
        }
    },
    data: function () {
        return {
            languageIndex: 0,
            languageList: [
                { 
                name: "cn",
                val: "中文"
                },
                {
                name: "en",
                val: "English"
                }
            ],
        }
    },
    methods: {
      // 切换语言
        changeLanguage(language) {
        if(language == 'en'){
            setup(language)
            this.languageIndex = 0
            return
        }else if(language == 'cn'){
            setup(language)
            this.languageIndex = 1
            return
        }

        if (this.languageIndex == this.languageList.length - 1) {
            setup(this.languageList[this.languageIndex].name);
            this.languageIndex = 0;
        } else {
            setup(this.languageList[this.languageIndex].name);
            this.languageIndex++;
        }
        },
        setDefaultLanguage() {
        let currentLanguage = window.localStorage.getItem("localeLanguage")
            for (let i = 0; i < this.languageList.length; i++) {
            if (currentLanguage == this.languageList[i].name) {
            this.language = this.languageList[i].val;
            if (i == this.languageList.length - 1) {
                this.languageIndex = 0;
            } else {
                this.languageIndex = i + 1;
            }
            }
            }
        },
    },
    created () {
        this.setDefaultLanguage()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
    width: 100%;
    background: url(../img/live_header_bj.png) no-repeat center;
    height: 50px;
    background-size: cover;
    padding: 10px 0 5px;
    margin: 0 auto;
    min-width: 980px;
    font-size: 16px;
    .h_left {
        float: left;
        margin-left: 20px;
        a {
            display: inline-block;
            height: 100%;
            padding-right: 20px;
            border-right: 1px solid #79464b;
        }
        img {
            height: 50px;
        }
        .title {
            font-size: 30px;
            margin-left: 20px;
            color: #fff;
            line-height: 50px;
            vertical-align: top;
        }
    }
    .h_right {
        float: right;
        line-height: 50px;
        vertical-align: middle;
        margin-right: 20px;
        .languageCon {
            font-size: 16px;
            color: #fff;
            vertical-align: middle;
            display: inline-block;
            cursor: pointer;
            .languageIcon {
                vertical-align: middle;
                margin-right: 5px;
            }
        }
    }
}
</style>
